import flatten from 'lodash.flatten';

/**
 * Find whether the passed trend data contains a timestamp.
 *
 * @param  {Array}  trends    trend data
 * @param  {Date | null} timestamp timestamp (in ms)
 * @return {Boolean}          true/false
 */
function existsIn(trends: any[], timestamp: Date | null): any {
  return flatten(trends.map((d) => d.data)).some(
    (d) => d.date.getTime() === timestamp
  );
}

export default existsIn;
